import {EvolutionHttpClient} from 'core/http-client/EvolutionHttpClient';
import {TResponse} from 'core/types';
import {TFeaturesResponse} from 'modules/features-toggle/types';

export class FeaturesToggleService extends EvolutionHttpClient {
    async getFeatures(): Promise<TResponse<TFeaturesResponse>> {
        const {data} = await this.get<TResponse<TFeaturesResponse>>({
            url: '/feature-toggles',
        });

        return data;
    }
}
